

    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import "leaflet/dist/leaflet.css";
    import { LatLng } from "leaflet";
    import { ApiClient } from "@/utilities/ApiClient";
    import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";

    @Component({
        components: { 
            ApiButton,
            LMap,
            LTileLayer,
            LMarker,
            LIcon
        }
    })

    export default class MapLocationModal extends Vue {

        //
        // -- properties
        //
        
        // map properties
        showMap: boolean = true;
        zoom: number = 12;
        center = new LatLng(55.3781, 3.4360);
        url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        latLng = new LatLng(55.3781, 3.4360);
        postCode: string = "";
        isHotel = false;

        //
        // -- methods
        //

        show(lat: number, lng: number, isHotel: boolean = false) {
            // this.postCode = postCode;
            this.loadLocation(lat, lng);
            this.isHotel = isHotel;
        }

        async loadLocation(lat: number, lng: number) {
            // const locationData = await ApiClient.get(`api/booking/PostCodeLocation?postCode=${postCode}`);
            // if (!locationData) { this.$bvModal.show("mapLoadingFailedModal"); return}
            this.zoom = 12;
            this.center = new LatLng(lat, lng);
            this.latLng = new LatLng(lat, lng);

            this.$bvModal.show("mapLocationModal");

            // fixes greyed out tiles problem due to not rendering correctly initially
            this.forceRerender()
        }

        forceRerender() {
            setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 250);
        }

        cancel() {
            this.$bvModal.hide("mapLocationModal");
        }
    }

